import { useState } from "react";
import { Wifi } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { ConnectionQualityBadge } from "@/components/ConnectionQualityIndicator";
import { SyncQueueBadge } from "@/components/SyncQueueVisualization";
import { OfflineIndicatorBadge } from "@/components/OfflineIndicatorBadge";

interface NetworkStatusGroupProps {
  pendingCount: number;
}

export const NetworkStatusGroup = ({ pendingCount }: NetworkStatusGroupProps) => {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 relative"
          aria-label="Network status"
        >
          <Wifi className="h-4 w-4 text-muted-foreground" />
          {pendingCount > 0 && (
            <span className="absolute -top-0.5 -right-0.5 h-2 w-2 rounded-full bg-primary animate-pulse" />
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-auto p-2 flex flex-col gap-2">
        <p className="text-xs font-medium text-muted-foreground px-2 pb-1 border-b border-border">Network Status</p>
        <div className="flex items-center gap-2 px-1">
          <ConnectionQualityBadge />
          <SyncQueueBadge />
          <OfflineIndicatorBadge pendingCount={pendingCount} />
        </div>
      </PopoverContent>
    </Popover>
  );
};
